import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';

import store from './store';
import App from './components/certifications/App.vue';

const lang = document.getElementsByTagName('html')[0].getAttribute('lang') || 'cs';
axios.defaults.headers['accept-language'] = lang;

Vue.use(VueAxios, axios);
Vue.use(Vuex);
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: lang,
  messages: {
    cs: {
      free: 'zdarma',
    },
    en: {
      free: 'free',
    },
  },
});

Vue.config.productionTip = false;

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('vue-filter');

  if (element != null) {
    new Vue({
      el: '#vue-filter',
      i18n,
      store,
      components: {
        App,
      },
      render: h => h(App, {
        props: {
          category: element.getAttribute('category') || null,
          field: element.getAttribute('field') || null,
          certificationRoot: element.getAttribute('certification_root'),
          query: element.getAttribute('query'),
        },
      }),
    });
  }
});
